import { createReducer, on } from '@ngrx/store';
import { SessionListItem } from '../../../core/models/session-list.model';
import { SessionsListActions } from './sessions-list.actions';

export type SessionsListState = {
  readonly sessions: ReadonlyArray<SessionListItem>;
  readonly total: number;
  readonly page: number;
  readonly perPage: number;
  readonly isLoading: boolean;
  readonly error: string | null;
};

export const initialState: SessionsListState = {
  sessions: [],
  total: 0,
  page: 1,
  perPage: 20,
  isLoading: false,
  error: null,
};

export const sessionsListReducer = createReducer(
  initialState,

  on(SessionsListActions.loadSessions, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(SessionsListActions.loadSessionsSuccess, (state, { response }) => ({
    ...state,
    sessions: response.sessions,
    total: response.total,
    page: response.page,
    perPage: response.perPage,
    isLoading: false,
  })),

  on(SessionsListActions.loadSessionsFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),
);
